export const locale = {
    lang: 'en',
    data: {
        PLACE: 'Where do you want to place these lists?',
        ACTIVITY: 'Activity',
        CANCEL: 'Cancel',
        SAVE: 'Save',
    }
};
